export default __webpack_public_path__ + "./fonts/card_travel.a011ab63.svg";